"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function InformativeFooter() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    label: "Facebook",
    href: "https://facebook.com"
  }, {
    icon: Instagram,
    label: "Instagram",
    href: "https://instagram.com"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    href: "https://linkedin.com"
  }, {
    icon: Twitter,
    label: "Twitter",
    href: "https://twitter.com"
  }];
  return <footer data-section-id="18804" id="rodapé-krb" className="dark bg-background text-foreground font-sans">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-10 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://absolute-tuna.10web.cloud/wp-content/uploads/2026/03/logo-krb.png" alt="KRB Accounting Services Logo" className="h-12 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Contabilidade e assessoria fiscal especializada para brasileiros e empresas na Irlanda. Segurança e conformidade para o seu negócio.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Contato</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground text-sm">
                  Dublin, Irlanda — Atendimento para todo o país
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <Link to="tel:+353800000000" className="text-muted-foreground text-sm hover:text-primary transition-colors">
                  +353 (0) 8X XXX XXXX
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <Link to="mailto:contato@krbaccounting.ie" className="text-muted-foreground text-sm hover:text-primary transition-colors">
                  contato@krbaccounting.ie
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Siga-nos</h3>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, index) => <Button key={index} data-index={index} asChild variant="ghost" size="icon" className="bg-secondary/10 text-foreground hover:bg-primary hover:text-primary-foreground rounded-full w-10 h-10 transition-all duration-300 border border-primary/20">
                  <Link to={social.href} aria-label={social.label}>
                    <social.icon className="w-5 h-5" />
                  </Link>
                </Button>)}
            </div>
          </div>
        </div>

        <Separator className="bg-primary/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-muted-foreground">
          <p>&copy; {currentYear} KRB Accounting Services Ltd. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>;
}